import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import CottonCubs from "./CottonCubs";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import ProductForm from "./components/admin/ProductForm";
import useAuth from "./hooks/useAuth";

export default function App() {
  const { isAuthenticated, login, logout } = useAuth();

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<CottonCubs />} />
        <Route path="/admin/login" element={
          isAuthenticated ? <Navigate to="/admin" replace /> : <AdminLogin onLogin={login} />
        } />
        <Route path="/admin" element={
          isAuthenticated ? <AdminLayout onLogout={logout} /> : <Navigate to="/admin/login" replace />
        }>
          <Route index element={<AdminDashboard />} />
          <Route path="products/new" element={<ProductForm />} />
          <Route path="products/:id" element={<ProductForm />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
